import { produce } from 'immer'
import { BudgetRequestListResponse } from 'src/models/budgetRequest.models'
import { PaginationResponse } from 'src/models/pagination.models'
import {
  GET_BUDGET_REQUEST_SUCCESS,
  GET_BUDGET_REQUESTS_FAILURE,
  GET_BUDGET_REQUESTS_INIT,
  GET_BUDGET_REQUESTS_SUCCESS,
  GetBudgetRequestsFailureAction,
  GetBudgetRequestsInitAction,
  GetBudgetRequestsSuccessAction,
  GetBudgetRequestSuccessAction,
  REMOVE_BUDGET_REQUEST,
  RemoveBudgetRequestAction,
} from 'src/redux/actions/data/budgetRequests.actions'

export interface BudgetRequestsState {
  loading: boolean
  listResponses: Record<string, BudgetRequestListResponse>
  requesterMe: {
    itemIDs: string[]
    pagination: PaginationResponse
  }
  approverMe: {
    itemIDs: string[]
    pagination: PaginationResponse
  }
}

const initialPaginationState: PaginationResponse = {
  numberOfPages: 0,
  page: 0,
  pageItemCount: 0,
  totalItems: 0,
}

export const initialState: BudgetRequestsState = {
  loading: false,
  listResponses: {},
  requesterMe: {
    itemIDs: [],
    pagination: initialPaginationState,
  },
  approverMe: {
    itemIDs: [],
    pagination: initialPaginationState,
  },
}

export type Actions =
  | GetBudgetRequestsSuccessAction
  | GetBudgetRequestsInitAction
  | GetBudgetRequestsFailureAction
  | GetBudgetRequestSuccessAction
  | RemoveBudgetRequestAction

const BudgetRequestsReducer = (
  state: BudgetRequestsState = initialState,
  action: Actions,
): BudgetRequestsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_BUDGET_REQUEST_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.budgetRequest.id]: action.payload.budgetRequest,
        }
        return draft
      }
      case GET_BUDGET_REQUESTS_INIT: {
        draft.loading = true
        return draft
      }
      case GET_BUDGET_REQUESTS_SUCCESS: {
        let namespace: 'approverMe' | 'requesterMe' | null

        if (action.payload.queryParameters.approver === 'me') {
          namespace = 'approverMe'
        } else if (action.payload.queryParameters.requester === 'me') {
          namespace = 'requesterMe'
        } else {
          namespace = null
        }

        action.payload.budgetRequest.reduce((acc, curr) => {
          acc.listResponses[curr.id] = curr

          if (namespace) {
            if (!acc[namespace].itemIDs.includes(curr.id))
              acc[namespace].itemIDs.push(curr.id)
          }

          return acc
        }, draft)

        if (namespace) {
          draft[namespace].pagination = action.payload.pagination
        }

        draft.loading = false
        return draft
      }
      case GET_BUDGET_REQUESTS_FAILURE: {
        draft.loading = false
        // TODO: Error handling will be handled in separate PR.
        return draft
      }

      case REMOVE_BUDGET_REQUEST: {
        const { budgetRequestId } = action.payload
        delete draft.listResponses[budgetRequestId]
        draft.requesterMe.itemIDs = draft.requesterMe.itemIDs.filter(
          (itemID) => itemID !== budgetRequestId,
        )
        draft.approverMe.itemIDs = draft.approverMe.itemIDs.filter(
          (itemID) => itemID !== budgetRequestId,
        )
        return draft
      }
    }
  })
}

export default BudgetRequestsReducer
